import React from 'react';
import PropTypes from 'prop-types';

import Package from './Package';
import styles from './PackageSelect.module.scss';

const PackageSelect = (
  {
    packages,
    handlePackageSelect,
    activePackage,
  },
) => {
  const listPackages = packages.map(
    (pkg) => (
      <Package
        key={pkg.pk}
        pkg={pkg}
        activePackage={activePackage}
        handlePackageSelect={handlePackageSelect}
      />
    ),
  );

  return <fieldset className={styles['package-select-wrapper']}>{listPackages}</fieldset>;
};

PackageSelect.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    pk: PropTypes.number,
    minimum_quantity: PropTypes.number,
    price_per_press_release: PropTypes.number,
    is_best_value: PropTypes.bool,
    is_most_popular: PropTypes.bool,
  })).isRequired,
  activePackage: PropTypes.number.isRequired,
  handlePackageSelect: PropTypes.func.isRequired,
};

export default PackageSelect;
